import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div data-testid="notfound-page" className="min-h-[70vh] flex items-center justify-center bg-[#121212] px-5">
      <div className="text-center">
        <p className="font-display text-7xl md:text-9xl text-[#C99C3A] tracking-tighter">404</p>
        <p className="mt-4 font-serif-italic text-2xl text-[#F5ECD7]">Lost your taco.</p>
        <Link to="/" className="mt-8 inline-flex btn-gold">Back Home</Link>
      </div>
    </div>
  );
}
